import { Moment } from 'moment';

export class DateRange {

    constructor(
        public from: Moment,
        public to: Moment
    ){}
}
